<div class="p-3 flex flex-column flex-auto">
  <div class="text-900 font-medium text-xl mb-3"><h3>{{RegisterTitleScreen}}
  </h3></div>

  <div style="margin-bottom:20px;">
    <button  pButton type="button" style="height: 50px;margin-top: 20px;" class="p-button p-button-outlined p-button-secondary" (click)="returnToList()">
      <span [class]="cameFromCalendar ? 'pi pi-calendar' : 'pi pi-chevron-left'" style="margin-right:8px;"></span>
      <span>{{cameFromCalendar ? 'Return to Calendar' : 'Return to List'}}</span>
    </button>
  </div>

  <div class="surface-card p-4 shadow-2 border-round">
    @if (!nonspecificregiser) {
      <p-table  #classTable
        [columns]="cols"
        [value]="ListRegistrants.attendees" sortField="name" [paginator]="true" [rows]="10"
        [showCurrentPageReport]="true" responsiveLayout="scroll"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        [rowsPerPageOptions]="[10,25,50]"
        [globalFilterFields]="['name']"
        [(selection)]="selectedItems"
        responsiveLayout="scroll"
        datakey="classID"
        [selectionPageOnly]="true">
        <ng-template #caption>
          <div class="flex">
            <button
              type="button"
              pButton
              pRipple
              (click)="classTable.exportCSV()"
              class="mr-2"
              pTooltip="Export to CSV"
              tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-file-excel" aria-hidden="true"></span></button>
              &nbsp;
              <button
                type="button"
                pButton
                pRipple
                (click)="exportPdf()"
                class="mr-2 p-button-warn"
                pTooltip="PDF"
                tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-file-pdf" aria-hidden="true"></span></button>
              </div>
            </ng-template>
            <ng-template #header>
              <tr>
                <th>
                  <p-tableheadercheckbox></p-tableheadercheckbox>
                </th>
                <th>
                  &nbsp;
                </th>
                <th pSortableColumn="name" width="90%">Name
                  <p-sorticon [field]="name"></p-sorticon>
                </th>
              </tr>
            </ng-template>
            <ng-template #body let-data>
              <tr>
                <td>
                  <p-tablecheckbox [value]="data"></p-tablecheckbox>
                </td>
                @if (data.hasquestionnaire != null &&data.hasquestionnaire) {
                  <td>
                    <span class="pi pi-list" pTooltip="Has Questionnaire"></span>
                  </td>
                }
                @if (!data.hasquestionnaire || data.hasquestionnaire == null) {
                  <td>
                    &nbsp;
                  </td>
                }
                <td style="cursor: pointer;" [routerLink]="['/customerscheduledsessionedit', data.membershipid]"><span style="text-decoration:underline;">{{data.name}}</span></td>
              </tr>
            </ng-template>
          </p-table>
        }

        @if (nonspecificregiser) {
          <p-table  #classTable
            [columns]="cols"
            [value]="ListRegistrants" sortField="name" [paginator]="true" [rows]="10"
            [showCurrentPageReport]="true" responsiveLayout="scroll"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            [rowsPerPageOptions]="[10,25,50]"
            [globalFilterFields]="['name']"
            [(selection)]="selectedItems"
            responsiveLayout="scroll"
            datakey="classID"
            [selectionPageOnly]="true">
            <ng-template #caption>
              <div class="flex">
                <button
                  type="button"
                  pButton
                  pRipple
                  (click)="classTable.exportCSV()"
                  class="mr-2"
                  pTooltip="Export to CSV"
                  tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-file-excel" aria-hidden="true"></span></button>
                  &nbsp;
                  <button
                    type="button"
                    pButton
                    pRipple
                    (click)="exportPdf()"
                    class="mr-2 p-button-warn"
                    pTooltip="PDF"
                    tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-file-pdf" aria-hidden="true"></span></button>
                  </div>
                </ng-template>
                <ng-template #header>
                  <tr>
                    <th pSortableColumn="name" width="90%">Name
                      <p-sorticon [field]="name"></p-sorticon>
                    </th>
                  </tr>
                </ng-template>
                <ng-template #body let-data>
                  <tr>
                    @if (data.membershipid) {
                      <td style="cursor: pointer;" [routerLink]="['/customerscheduledsessionedit', data.membershipid]"><span style="text-decoration:underline;">{{data.name}}</span></td>
                    }
                    @if (!data.membershipid) {
                      <td>{{data.name}}</td>
                    }
                  </tr>
                </ng-template>
              </p-table>
            }

            <div>
              <div class="field mb-4 col-12">
                @if (!nonspecificregiser) {
                  <label for="" class="font-medium">Send this email to everyone on the register. Everybody listed above will receive it - the tick boxes record attendance and do not change who is emailed: </label>
                  }<br>
                  @if (nonspecificregiser) {
                    <label for="" class="font-medium">Send this email to everyone on the register: </label>
                    }<br>
                    @if (ShowDynamicTextEditor) {
                      <div>
                        <div class="surface-card p-4 shadow-2 border-round">
                          <h5>Email Preview</h5>
                          <div style="overflow-x: hidden; height: calc(75vh - 348px)">
                            <div [innerHTML]="ExampleEmail | safe: 'html'">
                            </div>
                          </div>
                          <div class="field mb-4 col-12">
                            <p>Please fill out the text for each of your dynamic text areas</p>
                          </div>
                          @for (c of dynamicTextArray; track c) {
                            <div  class="field mb-4 col-12" style="margin-top: -40px; width:100%;">
                              <label for="template" class="font-medium">Dynamic Text {{c.index}}</label>
                              <br>
                                <textarea pInputText [(ngModel)]="c.text" style="width:100%"></textarea>
                              </div>
                            }
                            <p-button icon="pi pi-check" label="Save Text" styleClass="p-button p-button-success" (click)="SaveText()"></p-button>
                            &nbsp;
                            <p-button icon="pi pi-times" label="Cancel" styleClass="p-button p-button-danger"  (click)="CancelText()"></p-button>
                            <div style="clear:both;"></div>
                          </div>
                          <br>
                          </div>
                        }
                        <p-select [options]="EmailTemplates" [style]="{'width': '300px', 'float': 'left'}"  placeholder="Select a template" [showClear]="true" [(ngModel)]="selectedEmailTemplate" optionLabel="name" (onChange)="changeTemplate()"></p-select>

                      </div>
                      <div style="width: 100px; float: left; margin-top: -32px; margin-left: 10px;">
                        <p-button icon="pi pi-send" label="Send" styleClass="p-button p-button-success" (click)="sendEmailToRegister()"></p-button>
                      </div>

                    </div>
                  </div>
                  @if (!templateValid) {
                    <div class="text-danger" Style="clear:both; width:100%"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select a Template.</div>
                  }


                  @if (!nonspecificregiser) {
                    <div style="text-align: right; margin-top: 20px;">
                      <button pButton type="button" class="p-button-success" (click)="SaveRegister()"><span class="p-button-icon p-button-icon-left pi pi-save" aria-hidden="true"></span><span class="p-button-label">Save Register</span></button>
                      &nbsp;
                      <button pButton type="button" class="p-button-danger" (click)="Cancel()"><span class="p-button-icon p-button-icon-left pi pi-times" aria-hidden="true"></span><span class="p-button-label">Cancel</span></button>
                    </div>
                  }
                </div>


